import {FormatListBulletedTwoTone} from '@material-ui/icons';
import {
    SHIP_TO,
    SUPPLY_CENTER,
    CATEGORY_LIST,
    PRODUCT_LIST,
    ADD_CART,
    PRODUCT_SEARCH_FIELD,
    PRODUCT_MORE_INITIAL,
    PRODUCT_MORE_SUCCESS,
    PRODUCT_MORE_FAILURE,
    QUERY_CART,
    QUERY_CHANGE_SHIP,
    QUERY_EONE_INVENTORY,
    DELETE_CART,
    UPDATE_SHIP_TO,
    CART_PRICE,
    DEFAULT_SHIPTO_SC,
    PREVIEW_ORDER,
    UPDATE_PREVIEW_ORDER,
    ST_CONTACT_QUERY,
    ADD_ORDER,
    TM_PRODUCT,
    TM_PRODUCT_SEARCH,
    ORDER_QUANTITY,
    SET_OTHER_SHIPTO_NUMBER,
    QUERY_QUOTE,
    QUERY_CUSTOMER_QUOTE,
    SEARCH_HISTORY,
    CATEGROY_SELECTED,
    UPDATE_PRODUCTS_LIST,
    SWITCH_CHOOSE_PRICE,
    S_PRICE,
    FROM_PRODUCT_SEARCH_FIELD,
    FROM_SHOPPING_CART,
    UPDATE_OFFLINE_ORDER_CREDENTIAL,
    UPLOAD_FILE_LIMIT,
    CHECKED_ASSAYID,
    RANGE_CRD,
} from 'Actions/order';
import {loadProfile} from 'Utils/jwtUtil';
import update from 'immutability-helper';

const initialState = {};
let payload = {};

export function order(state = initialState, action) {
    switch (action.type) {
        case SHIP_TO:
            payload = action.payload.data;

            return Object.assign({}, state, {shipTo: payload});

        case SUPPLY_CENTER:
            payload = action.payload;

            return Object.assign({}, state, {supplyCenter: payload});

        case UPLOAD_FILE_LIMIT:
            payload = action.payload;

            return Object.assign({}, state, {fileLimits: payload});

        case CATEGORY_LIST:
            payload = action.payload;

            return Object.assign({}, state, {categoryList: payload});

        case ADD_CART:
            payload = action.payload.cartCount;

            return Object.assign({}, state, {cartCount: payload});

        case QUERY_CART:
            payload = action.payload;

            return Object.assign({}, state, {cartList: payload});

        case QUERY_CHANGE_SHIP:
            payload = action.payload;

            return Object.assign({}, state, {changeShipList: payload});
        case QUERY_EONE_INVENTORY:
            payload = action.payload;

            return Object.assign({}, state, {eOneInventoryList: payload});

        case DELETE_CART:
            payload = action.payload;

            return Object.assign({}, state, {deleteCart: payload});

        case CART_PRICE:
            payload = action.payload;

            if (payload.status === 'success') {
                return Object.assign({}, state, {cartPrice: payload});
            } else {
                console.log(
                    state.switchChoosePrice,
                    'switchChoosePrice----------------------reducers====================================',
                );
                let cartPrice = state.cartPrice;
                let switchChoosePrice = state.switchChoosePrice;
                if (switchChoosePrice === 'switchPrice') {
                    if (payload.status === 'cmgt_error') {
                        return Object.assign({}, state, {cartPrice: cartPrice});
                    } else {
                        return Object.assign({}, state, {cartPrice: payload});
                    }
                } else {
                    return Object.assign({}, state, {cartPrice: cartPrice});
                }
            }
        case SWITCH_CHOOSE_PRICE:
            payload = action.payload;

            return Object.assign({}, state, {switchChoosePrice: payload});
        case DEFAULT_SHIPTO_SC:
            payload = action.payload;

            return Object.assign({}, state, {defaultShipToAndSc: payload});

        case UPDATE_SHIP_TO:
            payload = action.payload;
            let profile = loadProfile();

            return Object.assign({}, state, {localData: profile});

        case PREVIEW_ORDER:
            payload = action.payload.data || {};

            return Object.assign({}, state, {previewOrder: payload});

        case UPDATE_PREVIEW_ORDER:
            payload = action.payload.data || {};

            return Object.assign({}, state, {previewOrder: payload});

        case RANGE_CRD:
            payload = action.payload.data || {};
            return Object.assign({}, state, {CRD_RangeList: payload});

        case ADD_ORDER:
            payload = action.payload.data || {};

            return Object.assign({}, state, {addOrder: payload});

        case ST_CONTACT_QUERY:
            payload = action.payload.data || {};

            return Object.assign({}, state, {stContactQuery: payload});

        case TM_PRODUCT:
            payload = action.payload || {};

            return Object.assign({}, state, {tmProductList: payload});

        case TM_PRODUCT_SEARCH:
            payload = action.payload || {};

            return Object.assign({}, state, {noScOrderResult: payload});
        case SET_OTHER_SHIPTO_NUMBER:
            payload = action.payload;

            return Object.assign({}, state, {otherShipToNumber: payload});
        case ORDER_QUANTITY:
            payload = action.payload || {};

            return Object.assign({}, state, {orderQuantity: payload});
        case QUERY_QUOTE:
            payload = action.payload || {};

            return Object.assign({}, state, {quoteInfor: payload});
        case QUERY_CUSTOMER_QUOTE:
            payload = action.payload || {};
            if (action.payload.append) {
                const {quoteCustomerInfor} = state;
                const prevData = Array.isArray(quoteCustomerInfor?.data)
                    ? quoteCustomerInfor.data
                    : [];
                const nextData = Array.isArray(action.payload.data)
                    ? action.payload.data
                    : [];
                action.payload.data = prevData.concat(nextData);
                action.payload.append = false;
            }
            return Object.assign({}, state, {quoteCustomerInfor: payload});
        case PRODUCT_SEARCH_FIELD:
            payload = action.payload || '';
            return Object.assign({}, state, {searchValue: payload});
        case FROM_PRODUCT_SEARCH_FIELD:
            payload = action.payload || '';
            return Object.assign({}, state, {fromProductSearchPage: payload});

        case FROM_SHOPPING_CART:
            payload = action.payload || '';
            return Object.assign({}, state, {fromShoppingCart: payload});

        case SEARCH_HISTORY:
            payload = action.payload || '';
            return Object.assign({}, state, {searchHistoryList: payload});

        case CATEGROY_SELECTED:
            payload = action.payload || '';
            return Object.assign({}, state, {categroySelected: payload});

        case PRODUCT_LIST:
        case PRODUCT_MORE_INITIAL:
        case PRODUCT_MORE_SUCCESS:
        case PRODUCT_MORE_FAILURE:
        case CHECKED_ASSAYID:
            return {
                ...state,
                ...action.payload,
            };

        case UPDATE_PRODUCTS_LIST:
            return update(state, {productList: action.payload});

        case UPDATE_OFFLINE_ORDER_CREDENTIAL:
            payload = action.payload;

            return Object.assign({}, state, {offlineOrderCredential: payload});

        case S_PRICE:
            payload = action.payload;

            if (payload.status === 'success') {
                return Object.assign({}, state, {sPrice: payload.data});
            } else {
                let sPrice = state.sPrice;
                return Object.assign({}, state, {sPrice: sPrice});
            }
            break;

        default:
            return state;
    }
}
